import React from 'react'
import * as  C from "../componentsM/index"

const Library = () => {
    return (
        <>

            <C.Hero title={"LIBRARY"}
                image={"/hero/li.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>At The International School, the libraries at the Primary and Secondary campuses are the centre of the school, in terms of their importance. They are not just places for silent reading, but promote and facilitate teaching and learning. For this reason, the librarian at TIS is a Teacher Librarian. The Teacher Librarian is the support system, the person who re-enforces IB teaching and learning in order to support and facilitate inquiry, action and reflection.</p>

                    <p>The libraries are intellectually stimulating spaces, inviting environments. They provide access to appropriate resources including digital resources, which are necessary for inquiry, material that provides information to support learning, and fictional literature encompassing many genres.</p>


                    <p>With over 7,500 resources in both the primary and secondary libraries, there is a range of reference books for older students, to books for our little learners, as well as resources for teachers. The libraries have it all-opportunities for debates, to book discussions, to playing board games! The libraries stimulate collaborative practices and disseminate meaningful information to teachers and students.</p>



                </div>
            </section>

        </>

    )
}

export default Library